<template>
  <div class="main">
    <div class="page">
      <div class="bg" v-if="show_bg"></div>
      <div id="thai_style_title" v-if="show_editor">
        選出你的泰style
      </div>
      <div id="people-wrapper" :class="share ? 'done' : ''" ref="canvasImage">
        <div class="logo" v-if="show_logo">
          <img src="../assets/images/logo.png" alt="">
        </div>
        <div class="thai_logo" v-if="show_thai_logo">
          <img src="../assets/images/thai_logo.png" alt="">
        </div>
        <div id="people-canvas" :class="show_editor ? 'editor' : ''" v-if="!finish">
          <div id="people-inner">
            <div id="slogan" class="people-part" v-if="people['slogan']" v-bind:style="{ 'background-image': 'url(' + people['slogan'] + ')' }"></div>
            <div id="slogan_other" class="people-part drechifont" v-if="people.slogan_other">
              <p v-for="text in slogan_other">{{ text }}</p>
            </div>
            <div id="accessory" class="people-part" v-if="people['accessory']" v-bind:style="{ 'background-image': 'url(' + people['accessory'] + ')' }"></div>
            <div id="hair" class="people-part" v-if="people['hair']" v-bind:style="{ 'background-image': 'url(' + people['hair'] + ')' }"></div>
            <div id="cloth" class="people-part" v-if="people['cloth']" v-bind:style="{ 'background-image': 'url(' + people['cloth'] + ')' }"></div>
            <div id="face" class="people-part" v-if="people['face']" v-bind:style="{ 'background-image': 'url(' + people['face'] + ')' }"></div>
            <div id="people" class="people-part" :style="'background-image: url(' + require('../assets/images/main/people.png') +')'"></div>
            <div id="people-shadow" class="people-part" :style="'background-image: url(' + require('../assets/images/main/shadow.png') +')'"></div>
            <div id="background" class="people-part" v-if="people['background']" v-bind:style="{ 'background-image': 'url(' + people['background'] + ')' }"></div>
          </div>
        </div>

        <div id="complete-canvas" ref="addImage" v-if="finish"></div>

        <div id="select-section" v-if="show_editor">
          <div :id="item.key + '-select'" class="cover" v-for="item in items" v-show="!edit_menu || edit_menu == item.key">
            <div class="cover-image" @click="toggle(item.key)">
              <img :src="require('../assets/images/button/' + item.key + '/' + item.key + '_cover.png')" :alt="item.key + '_cover'">
            </div>
            <div class="select-title" v-html="item.title"></div>
            <div class="options" v-if="options[item.key]">
              <div class="item" v-for="i in item.number" @click="updatePeople(item.key, i)">
                <img :src="require('../assets/images/button/' + item.key + '/' + item.key + i + '.png')" :alt="item.key + i">
              </div>
            </div>
          </div>
        </div>

        <div id="slogan-section" v-if="show_slogan_option">
          <div class="slogan-option" @click="updateSlogan(i)" v-for="i in 3" v-bind:style="{ 'background-image': 'url(' + require('../assets/images/slogan/slogan' + i + '.png') + ')' }"></div>
          <div id="slogan_title" v-if="show_slogan_option">
            點選你的浪漫泰小語☝<br/>或自行輸入你的泰小語
            <textarea class="form-control my-3" rows="2" v-model="people.slogan_other"></textarea>
          </div>
        </div>
      </div>

      <div id="loading" v-if="load">
        loading...
      </div>
      <div class="custom-btn start-btn" @click="start()" v-if="start_btn">
        開始製作
      </div>
      <div :class="'custom-btn slogan-btn' + (show_editor ? ' edit' : '')" @click="showSlogan()" v-if="slogan_btn">
        MY泰完成
      </div>
      <div class="custom-btn slogan-other-btn" @click="updateSloganOther()" v-if="slogan_other_btn">
        MY泰完成
      </div>
      <div class="custom-btn done-btn" @click="done()" v-if="finish_btn">
        完成
      </div>

      <div class="error-message" v-if="show_error">
        <span v-text="error_message"></span><span class="note">尚未完成!</span>
      </div>

      <div class="share-section" v-if="share">
        <a id="download" href="#" @click="download" download="image.png">
          <img src="../assets/images/download.png" alt="">
          下載圖片
        </a>
        <div id="fb-share" @click="fb_share">
          <img src="../assets/images/fb-share.png" alt="">
          FB分享
        </div>
        <div id="paly-again" @click="play_again">
          <img src="../assets/images/play-again.png" alt="">
          再玩一次
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import html2canvas from 'html2canvas'

  export default {
    name: 'Home',
    data() {
      return {
        load: false,
        show_bg: true,
        show_logo: true,
        show_thai_logo: true,
        start_btn: true,
        slogan_btn: false,
        slogan_other_btn: false,
        finish_btn: false,
        show_editor: false,
        edit_slogan: false,
        show_slogan_option: false,
        show_error: false,
        error_message: 'my泰style',
        share: false,
        finish: false,
        people: {
          'face': require('../assets/images/face/face5.png'),
          'hair': require('../assets/images/hair/hair2.png'),
          'cloth': require('../assets/images/cloth/cloth8.png'),
          'accessory': require('../assets/images/accessory/accessory1.png'),
          'background': null,
          'slogan': null,
          'slogan_other': null,
        },
        options: {
          'face': false,
          'hair': false,
          'cloth': false,
          'accessory': false,
          'background': false,
        },
        items: {
          face: {
            key: 'face',
            number: 8,
            title: '五官'
          },
          hair: {
            key: 'hair',
            number: 8,
            title: '髮型'
          },
          cloth: {
            key: 'cloth',
            number: 8,
            title: '服飾'
          },
          accessory: {
            key: 'accessory',
            number: 8,
            title: '配件'
          },
          background: {
            key: 'background',
            number: 4,
            title: '背景'
          },
        },
        edit_menu: '',
      }
    },
    computed: {
      slogan_other: function () {
        return this.people.slogan_other.split("\n")
      }
    },
    methods: {
      start: function () {
        this.playClick();

        this.show_bg = false;
        this.show_logo = false;
        this.show_thai_logo = false;
        this.start_btn = false;
        this.slogan_btn = true;
        this.slogan_other_btn = false;
        this.show_editor = true;
        this.people.face = null;
        this.people.hair = null;
        this.people.cloth = null;
        this.people.accessory = null;
        this.people.background = null;
      },
      toggle: function (type) {
        this.playClick();

        this.options[type] = !this.options[type];

        if (this.options[type]) {
          this.edit_menu = type;
        } else {
          this.edit_menu = '';
        }

        this.show_error = false;
      },
      updatePeople: function (type, id) {
        this.playClick();

        this.people[type] = require('../assets/images/' + type + '/' + type + id + '.png');
        this.options[type] = !this.options[type];
        this.edit_menu = '';
      },
      showSlogan: function () {
        this.playClick();

        if (!this.people.face) {
          this.show_error = true;
          this.error_message = this.items.face.title;

          this.playError();

          return false;
        }

        if (!this.people.hair) {
          this.show_error = true;
          this.error_message = this.items.hair.title;

          this.playError();

          return false;
        }

        if (!this.people.cloth) {
          this.show_error = true;
          this.error_message = this.items.cloth.title;

          this.playError();

          return false;
        }

        if (!this.people.accessory) {
          this.show_error = true;
          this.error_message = this.items.accessory.title;

          this.playError();

          return false;
        }

        if (!this.people.background) {
          this.show_error = true;
          this.error_message = this.items.background.title;

          this.playError();

          return false;
        }

        this.show_editor = false;
        this.show_slogan_option = true;
        this.slogan_btn = false;
        this.slogan_other_btn = true;
      },
      updateSlogan: function (id) {
        this.playClick();

        this.people['slogan'] = require('../assets/images/slogan/slogan' + id + '_black.png');
        this.show_slogan_option = false;
        this.slogan_other_btn = false;
        this.finish_btn = true;
        this.show_logo = true;
        this.show_thai_logo = true;
      },
      updateSloganOther: function () {
        this.playClick();

        this.show_slogan_option = false;
        this.slogan_other_btn = false;
        this.finish_btn = true;
        this.show_logo = true;
        this.show_thai_logo = true;

        _jf.flush();
      },
      done: function () {
        this.playClick();

        this.share = true;
        this.finish = true;
        this.finish_btn = false;
        this.show_logo = false;
        this.show_thai_logo = false;

        this.generatorImage();

        this.playFinish();
      },
      fb_share: function () {
        this.playClick();

        window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location);
      },
      play_again: function () {
        this.playClick();

        location.reload();
      },
      download: function () {
        this.playClick();

        $('#download').attr('href', $('#complete-canvas canvas')[0].toDataURL("image/png;base64"));
      },
      generatorImage() {
        html2canvas(this.$refs.canvasImage, {
          scale: 2,
          dpi: 300,
          backgroundColor: '#f9efdc',
        }).then(canvas => {
          this.$refs.addImage.append(canvas);
        })
      },
      playClick() {
        let a = new Audio(require('../assets/sound/click.mp3'));
        a.play();
      },
      playError() {
        let a = new Audio(require('../assets/sound/error.mp3'));
        a.play();
      },
      playFinish() {
        let a = new Audio(require('../assets/sound/finish.mp3'));
        a.play();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue